import React from "react";
import { DragSource, DropTarget } from "react-dnd";
import { findDOMNode } from "react-dom";
import ReelClip from "components/ReelClip";

class DNDReelClip extends React.Component {
  render() {
    const { connectDragSource, connectDropTarget, isDragging } = this.props;

    return connectDragSource(
      connectDropTarget(
        <div style={{ opacity: isDragging ? 0 : 1 }}>
          <ReelClip {...this.props} />
        </div>
      )
    );
  }
}

const dragSourceSpec = {
  beginDrag(props) {
    return {
      id: props.clip.id,
      index: props.index
    };
  }
};

const dragSourceCollect = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

const dropTargetSpec = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get horizontal breakpoints
    const hoverLeftThird =
      (hoverBoundingRect.right - hoverBoundingRect.left) * (1 / 3);
    const hoverRightThird =
      (hoverBoundingRect.right - hoverBoundingRect.left) * (2 / 3);

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the left
    const hoverClientX = clientOffset.x - hoverBoundingRect.left;

    // Only perform the move when the mouse has crossed half of the items width
    // When dragging right, only move when the cursor is below 33%
    // When dragging left, only move when the cursor is above 66%

    // Dragging right
    if (dragIndex < hoverIndex && hoverClientX < hoverLeftThird) {
      return;
    }

    // Dragging left
    if (dragIndex > hoverIndex && hoverClientX > hoverRightThird) {
      return;
    }

    // Time to actually perform the action
    props.moveClip(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

const dropTargetCollect = connect => {
  return {
    connectDropTarget: connect.dropTarget()
  };
};

export default DropTarget(
  "ReelClip",
  dropTargetSpec,
  dropTargetCollect
)(DragSource("ReelClip", dragSourceSpec, dragSourceCollect)(DNDReelClip));



// WEBPACK FOOTER //
// ./src/components/DNDReelClip.js